import { render, staticRenderFns } from "./err-list.vue?vue&type=template&id=24e63bce&scoped=true&"
import script from "./err-list.vue?vue&type=script&lang=js&"
export * from "./err-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e63bce",
  null
  
)

export default component.exports